import React from "react";
import Iframe from "../../../component/formikComponent/Iframe";

interface IframeSectionProps {
    flkState: any;
}

const IframeSection: React.FC<IframeSectionProps> = ({
    flkState
}) => {
// console.log("flkState", flkState);
    // Only one URL now
    const signingUrl = flkState.signingUrl;
    const type = flkState.type;

    if (!signingUrl || !type) {return null;} // No TFN/SUPER/DYNAMIC active


    return (
        <div className="signed_url_wrapper">
            <Iframe url={signingUrl} />
        </div>
    );
};

export default IframeSection;
